import { Component, Input, OnInit , OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop, Observable } from 'rxjs';
import { Day, daysOfTheWeek } from 'constants/days-of-the-week';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TranslatePipe, TranslationKey } from 'pipes/translate.pipe';

@Component({
    selector: 'app-pool-days-of-week-with-restriction',
    templateUrl: './pool-days-of-week-with-restriction.component.html',
    styleUrls: ['./pool-days-of-week-with-restriction.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR, useExisting: PoolDaysOfWeekWithRestrictionComponent, multi: true
        }],
    standalone: false
})
export class PoolDaysOfWeekWithRestrictionComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() restrictedDays!: number[];

  public daysOfWeek: { value: Day, checked: boolean, isQueueAllowed: boolean }[];

  constructor(private translatePipe: TranslatePipe){
    this.daysOfWeek = daysOfTheWeek.map((day, i) => {
      return {
        value: day,
        checked: true,
        isQueueAllowed: false
      };
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if(changes.restrictedDays.currentValue.length != 7){
      const fullArray = [0, 1, 2, 3, 4, 5, 6];
      const missingNumber = fullArray.filter((num :any)  => !changes.restrictedDays.currentValue.includes(num));
       missingNumber.forEach((ele:any)=>{
         this.daysOfWeek[ele].isQueueAllowed=false
        this.daysOfWeek[ele].checked=true
       })
      
    }
  }
  ngOnInit(): void {}

  // Form functions
  private onChangeCallback: (_: any) => void = noop;
  private onTouchedCallback = noop;

  // Handle occurrence change
  public checkboxChange(value: any, event: MatSlideToggleChange): void {
    this.daysOfWeek.forEach((day) => {
      if (day.value === value) {
        day.checked = event.checked;

        if(event.checked == true){
          day.isQueueAllowed= false
        }
      
      }
    });
    this.onTouchedCallback();
    this.onChangeCallback(this.getSelectedDays());
    
    
  }

  // Update value from parent
  public writeValue(selectedDays: any): void {
    this.daysOfWeek = this.daysOfWeek.map((day,index) => {
      
      return {
        ...day,
        checked: selectedDays.length > 0 ? selectedDays.find((i: any) => i.value === day.value).checked : true,
        isQueueAllowed: selectedDays.length == 0 ? false : selectedDays[index]?.isQueueAllowed
       
        
      };
    });
  }

  // Update parent form value
  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  // Update parent form control has been touched
  public registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

   getSelectedDays(): any {
    return this.daysOfWeek;
  }

  public getToolTip(isRestricted: boolean): Observable<string> {
    const restricted = 'tooltip.message.pool.restrictedOccurrence';
    const unrestricted = 'tooltop.message.pool.unrestrictedOccurrence';
    const key: TranslationKey = isRestricted ? restricted : unrestricted;
    return this.translatePipe.transform(key);
  }

  checkboxData(data:any , event:any,day:any){
    this.daysOfWeek.forEach((day) => {
      if (day.value === data) {
        day.isQueueAllowed = event.checked;
      }
    });
       this.onTouchedCallback();
    this.onChangeCallback(this.getSelectedDays());
  }
}
